// extracted by mini-css-extract-plugin
export default {"header":"EjKuKM","headerRightSide":"FiTaYa","moreButton":"xL4Qzz"};